import InfoBar from "../infoBar.component";
import CountInfoTag from "../infoTags/count.infoTag.infoBar.component";

const ShipmentInfoBar = ({ metaData = { totalCount: 0 }, label = "" }) => {
  return (
    <InfoBar>
      <CountInfoTag>Count: {metaData?.totalCount || 0}</CountInfoTag>
    </InfoBar>
  );
};

export default ShipmentInfoBar;
